































































































































































































































import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/dataZoom/DataZoomModel'
import 'echarts/lib/component/dataZoomInside'
import 'echarts/lib/component/dataZoomSlider'
import 'echarts/lib/component/dataZoomSelect'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markLine'

import { Query, Item } from '@/types/data-log'

import { mapState } from 'vuex'

import Mixins from './mixin'
import moment from 'moment'

import { QueryRecordedData } from '@/api/data-logger'

import { TrendSeries, Field, SeriesData, SelectOption, Legend } from './types'

const utcMinutesOffset = moment().utcOffset()

function getRandomColor() {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export default Mixins.extend({
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingData: false,
      form: {
        limit: 5000,
        currentPage: 1,
        rowsCount: 0,
        resolution: '1h',
        elDatePicker: [0, 0],
      },
      statusBusy: false,

      optsResolution: [
        // { value: '1s', text: '1 second' },
        // { value: '10s', text: '10 seconds' },
        // { value: '30s', text: '30 seconds' },
        { value: '1m', text: '1 minute' },
        // { value: '2m', text: '2 minute' },
        { value: '5m', text: '5 minutes' },
        { value: '10m', text: '10 minutes' },
        { value: '30m', text: '30 minutes' },
        { value: '1h', text: '1 hour' },
        { value: '6h', text: '6 hours' },
        { value: '8h', text: '8 hours' },
        { value: '12h', text: '12 hours' },
        { value: `1d,-${utcMinutesOffset}m`, text: '1 day' },
      ] as SelectOption[],
      legend: {
        fields: [
          // { key: "color", label: " " },
          { key: 'parameter', label: 'Parameter' },
          {
            key: 'standard',
            thStyle: { width: '160px' },
            tdClass: 'text-right',
          },
          {
            key: 'min',
            label: 'Min',
            thStyle: { width: '160px' },
            tdClass: 'text-right',
          },
          {
            key: 'max',
            label: 'Max',
            thStyle: { width: '160px' },
            tdClass: 'text-right',
          },
          {
            key: 'avg',
            label: 'Avg',
            thStyle: { width: '160px' },
            tdClass: 'text-right',
          },
          {
            key: 'unit',
            label: 'Unit',
            thStyle: { width: '120px' },
          },
        ],
        items: [] as Legend[],
        // eslint-disable-next-line
        status: {} as any,
      },
      options: {
        animation: false,
        legend: {
          show: false,
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        },

        tooltip: {
          trigger: 'axis',
          //show: true,   //default true
          showDelay: 0,
          hideDelay: 50,
          transitionDuration: 0,
          // backgroundColor: 'rgba(200,200,200,1)',
          // borderColor: '#000',
          // borderRadius: 8,
          // borderWidth: 2,
          padding: 10,
          // eslint-disable-next-line
          position: function(p: any) {
            return [p[0] + 20, p[1] - 10]
          },
          // eslint-disable-next-line
          formatter: (params: any, ticket: any, callback: any) => {
            // eslint-disable-next-line
            const series = (this as any).options.series
            let res =
              '<table class="table table-sm table-bordered m-0 text-light table-tooltip">'
            res +=
              '<tr><td colspan="3">' +
              moment(params[0].axisValue).format('DD MMMM YYYY, HH:mm:ss') +
              '</td></tr>'

            for (let i = 0, l = params.length; i < l; i++) {
              const serie = series.find(
                // eslint-disable-next-line
                (item: any) => item.name === params[i].seriesName
              )
              const value =
                typeof params[i].value[1] === 'number'
                  ? params[i].value[1].toFixed(3)
                  : params[i].value[1]

              res +=
                '<tr><td>' +
                `<i class="fa fa-circle" style="color: ${serie.color};"></i> ` +
                serie.labelHTML +
                '</td><td>' +
                value +
                '</td><td>' +
                serie.unitHTML +
                '</td></tr>'
            }

            res += '</table>'
            setTimeout(function() {
              callback(ticket, res)
            }, 100)
            return 'loading'
          },
        },

        xAxis: {
          type: 'time',
          splitLine: {
            show: true,
          },
        },

        yAxis: [
          {
            type: 'value',
            // boundaryGap: [0, '100%'],
            splitNumber: 5,
            axisLabel: {
              show: true,
            },
          },
          {
            position: 'right',
            type: 'value',
            // boundaryGap: [0, '100%'],
            splitNumber: 5,
            axisLabel: {
              show: true,
            },
          },
        ],

        dataZoom: [
          {
            start: 0,
            end: 100,
          },
          // {
          //   type: 'slider',
          //   yAxisIndex: 0,
          //   filterMode: 'empty',
          // },
          {
            type: 'inside',
            xAxisIndex: 0,
          },
        ],
        series: [] as TrendSeries[],
      },
      printing: false,
      printingItems: [] as Legend[],
      // eslint-disable-next-line
      slider: {} as any,
    }
  },

  computed: {
    fields(): Field[] {
      return [
        { key: 'n', label: '#' },
        { key: 'time', label: 'Timestamp' },
        ...this.dataLoggerItems.map((item: Item) => {
          return { key: item.tagUID, label: item.name }
        }),
      ]
    },
    ...mapState('tag', { tags: 'items' }),
  },

  methods: {
    // eslint-disable-next-line
    generateLegend(series: TrendSeries[]) {
      // eslint-disable-next-line
      this.legend.items = series.map((e) => {
        e.show = this.legend.status[e.name]
          ? this.legend.status[e.name].show
          : true

        if (e.show) {
          this.showSeries(e)
        } else {
          this.hideSeries(e)
        }
        // eslint-disable-next-line
        const data = e.data.map((e: any) => e[1])
        const s: Legend = {
          name: e.name,
          color: e.color,
          show: e.show,
          parameter: e.labelHTML,
          unit: e.unitHTML,
          standard: e.standard,
          min: Math.min(...data).toFixed(2),
          max: Math.max(...data).toFixed(2),
          avg: (() => {
            // eslint-disable-next-line
            const sum = data.reduce(function(a: any, b: any) {
              return a + b
            })
            return (sum / data.length).toFixed(2)
          })(),
        }

        return s
      })
      // console.log(this.legend.items)

      function compare(a: Legend, b: Legend) {
        if (a.parameter < b.parameter) {
          return -1
        }
        if (a.parameter > b.parameter) {
          return 1
        }
        return 0
      }

      this.legend.items.sort(compare)
    },

    toggleLegend(item: TrendSeries) {
      item.show = !item.show

      if (item.show) {
        this.showSeries(item)
      } else {
        this.hideSeries(item)
      }

      this.legend.status[item.name] = this.legend.status[item.name] || {}
      this.legend.status[item.name].show = item.show
      localStorage.setItem(
        'historicalTrend_legend_status',
        JSON.stringify(this.legend.status)
      )
    },

    showSeries(item: TrendSeries) {
      // eslint-disable-next-line
      ;(this.$refs as any).echarts.dispatchAction({
        type: 'legendSelect',
        name: item.name,
      })
    },

    hideSeries(item: TrendSeries) {
      // eslint-disable-next-line
      ;(this.$refs as any).echarts.dispatchAction({
        type: 'legendUnSelect',
        name: item.name,
      })
    },

    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    // Initialization
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    initForm() {
      this.dataLoggerId = this.optsDataLogger[0].value as number
    },

    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    // Recorded data operation
    //---------------------------------------------------------------------------------------------------------------------------------------------------------
    async queryRecordedData(q: Query) {
      this.loadingData = true
      const Results = await QueryRecordedData([q])
      this.loadingData = false

      if (Results.length < 1) {
        return
      }

      const results = Results[0]

      if (results.length < 2) {
        this.form.rowsCount = 0
        return
      }

      // Series pertama adalah data
      const dataResult = results[0]
      // Series terakhir adalah jumlah record
      const countResult = results[1]

      if (!Array.isArray(dataResult.Series)) {
        this.form.rowsCount = 0
        return
      }

      if (!Array.isArray(countResult.Series)) {
        this.form.rowsCount = 0
        return
      }
      if (countResult.Series.length > 0) {
        this.form.rowsCount = countResult.Series[0].values[0][1]
      }

      const seriesCount = dataResult.Series.length
      if (seriesCount < 1) return

      const valuesCount = dataResult.Series[0].values.length
      const columns = dataResult.Series[0].columns

      const series = dataResult.Series[0]

      interface MapSeries {
        [tagUID: string]: TrendSeries
      }

      const trendSeries: MapSeries = {}

      for (let index = 2; index < this.fields.length; index++) {
        const f = this.fields[index]

        // console.log(f)

        trendSeries[f.key] = {
          name: f.label,
          tag: f.key,
          type: 'line',
          smooth: true,
          hoverAnimation: false,
          showSymbol: false,
          data: [] as SeriesData[],
          show: true,
          // color,
        } as TrendSeries

        if (
          typeof this.tags[f.key] != undefined &&
          typeof this.tags[f.key].attributes == 'object' &&
          this.tags[f.key].attributes != null
        ) {
          // Jika attribute pada tag yang bersangkutan di set true, hapus series untuk tag tersebut
          if (this.tags[f.key].attributes.hideFromTrend) {
            delete trendSeries[f.key]
            continue
          }
          trendSeries[f.key] = {
            ...trendSeries[f.key],
            ...this.tags[f.key].attributes.series,
          }
          trendSeries[f.key].color =
            this.tags[f.key].attributes.color || getRandomColor()
          trendSeries[f.key].labelHTML =
            this.tags[f.key].attributes.labelHTML || f.label
          trendSeries[f.key].unitHTML = this.tags[f.key].attributes.unitHTML
          trendSeries[f.key].standard = this.tags[f.key].attributes.standard

          trendSeries[f.key].yAxisIndex = this.tags[f.key].attributes.yAxisIndex
        } else {
          trendSeries[f.key].color = getRandomColor()
          trendSeries[f.key].labelHTML = f.label
        }
      }

      for (let valueIndex = 0; valueIndex < valuesCount; valueIndex++) {
        for (let columnIndex = 1; columnIndex < columns.length; columnIndex++) {
          const columnName = columns[columnIndex]

          if (trendSeries[columnName]) {
            trendSeries[columnName].data.push([
              series.values[valueIndex][0],
              series.values[valueIndex][columnIndex],
            ])
          }
        }
      }

      this.options.series = []
      for (const tagUID in trendSeries) {
        this.options.series.push(trendSeries[tagUID])
      }
      // console.log(this.options.series)
      this.generateLegend(this.options.series)
      this.slider._state.value = [0, 0]
      this.slider.options.value = 0
      this.slider.options.max = this.options.series[0].data.length
    },

    async readRecord() {
      if (this.dataLoggerId == -1) {
        return
      }

      if (this.fields.length < 3) return

      this.statusBusy = true

      try {
        const timeStart = moment(this.form.elDatePicker[0]).toDate()
        const timeEnd = moment(this.form.elDatePicker[1] - 1).toDate()

        const fields: string[] = []
        for (let i = 2; i < this.fields.length; i++) {
          fields.push(this.fields[i].key)
        }

        const q: Query = {
          dataLoggerId: this.dataLoggerId,
          timeStart,
          timeEnd,
          fields,
          limit: this.form.limit,
          offset: (this.form.currentPage - 1) * this.form.limit,
          resolution: this.form.resolution,
        }

        await this.queryRecordedData(q)
      } catch (er) {
        this.$toast.error('Failed to read recorded data.')
      }
      this.statusBusy = false
    },

    //---------------------------------------------------------------------------------------------------------------------------
    // Toolbar events
    //---------------------------------------------------------------------------------------------------------------------------
    async onToolbarShow() {
      this.options.series = []
      // eslint-disable-next-line
      ;(this as any).$refs.echarts.clear()
      await this.readRecord()
    },

    //---------------------------------------------------------------------------------------------------------------------------
    // Print events
    //---------------------------------------------------------------------------------------------------------------------------
    onPrint() {
      // eslint-disable-next-line
      const slider: any = document.getElementsByClassName('slider-horizontal')
      slider[0].hidden = true
      this.printing = true
      this.printingItems = []
      this.legend.items.map((item) => {
        if (item.show) {
          this.printingItems.push(item)
        }
      })
      const index = this.slider._state.value[0]
      setTimeout(() => {
        // eslint-disable-next-line
        ;(this.$refs as any).echarts.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index,
        })
      }, 300)
      setTimeout(() => {
        window.print()
      }, 500)
    },

    showTooltip() {
      const index = this.slider._state.value[0]
        // eslint-disable-next-line
      ;(this.$refs as any).echarts.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: index,
      })
    },
  },

  mounted() {
    // eslint-disable-next-line
    const self = this as any
    window.onbeforeprint = function() {
      if (!self.printing) {
        // eslint-disable-next-line
        const slider: any = document.getElementsByClassName('slider-horizontal')
        slider[0].hidden = true
        self.printing = true
        self.printingItems = []
        // eslint-disable-next-line
        self.legend.items.map((item: any) => {
          if (item.show) {
            self.printingItems.push(item)
          }
        })
        setTimeout(() => {
          self.showTooltip()
        }, 300)
      }
    }
    window.onafterprint = function() {
      // eslint-disable-next-line
      const slider: any = document.getElementsByClassName('slider-horizontal')
      slider[0].hidden = false
      self.printing = false
    }

    // generate slider
    // const sliderData = this.options.series[0].data

    // eslint-disable-next-line
    this.slider = new (window as any).Slider('#ex9', {
      tooltip: 'hide',
      step: 1,
      min: 0,
      max: 0,
      // formatter: function(value) {
      //   return 'Current value: ' + sliderData[parseFloat(value)][0]
      // },
    })
    let cSlide = 0
    // eslint-disable-next-line
    this.slider.on('slide', function(v: any) {
      if (cSlide !== v) {
        cSlide = v
        self.showTooltip()
      }
    })

    // eslint-disable-next-line
    this.slider.on('change', function(e: any) {
      if (cSlide !== e.newValue) {
        cSlide = e.newValue
        self.showTooltip()
      }
    })
  },

  async created() {
    // set default picker
    const cDate = moment().format('YYYY-MM-DD')
    this.form.elDatePicker[0] = moment(cDate).valueOf()
    this.form.elDatePicker[1] = moment().valueOf()

    const legendStatus = localStorage.getItem('historicalTrend_legend_status')
    if (legendStatus) {
      this.legend.status = JSON.parse(legendStatus)
    }

    await this.find()
    this.initForm()
    await this.findItem()

    this.parseInput()
    this.options = Object.assign(
      this.options,
      this.value.attributes.chartOptions
    )

    if (this.value.attributes.updateOnPageOpen) {
      await this.readRecord()
    }
  },
})
